import { Box, Paper, Skeleton } from '@mui/material';
import cartIllustration from '../../../assets/images/cart-Illustration.svg';
import {
  discoveryActionsSx,
  discoveryCardSx,
  discoveryCardWrapSx,
  discoveryCartIllustrationLoadingSx,
  discoveryContainerSx,
  discoveryHeaderSkeletonStackSx,
  discoveryHeaderSx,
  discoveryHeaderWrapSx,
  discoveryPanelLoadingSx,
} from './styles';

export const HubLoadingCard = () => (
  <Box sx={discoveryContainerSx}>
    <Box sx={discoveryHeaderWrapSx}>
      <Box sx={discoveryHeaderSx}>
        <Box sx={discoveryHeaderSkeletonStackSx}>
          <Skeleton
            variant="text"
            width="79%"
            height={32}
            sx={{ transform: 'none', background: 'rgba(0, 0, 0, 0.04)', borderRadius: '16px' }}
          />
          <Skeleton
            variant="text"
            width="69%"
            height={20}
            sx={{ transform: 'none', background: 'rgba(0, 0, 0, 0.04)', borderRadius: '16px' }}
          />
        </Box>
        <Box sx={discoveryActionsSx}>
          <Skeleton variant="rounded" width={92} height={56} sx={{ background: 'rgba(0, 0, 0, 0.04)', borderRadius: '8px' }} />
          <Skeleton variant="rounded" width={92} height={56} sx={{ background: 'rgba(0, 0, 0, 0.04)', borderRadius: '8px' }} />
        </Box>
      </Box>
    </Box>
    <Box sx={discoveryCardWrapSx}>
      <Paper sx={discoveryCardSx}>
        <Box sx={discoveryPanelLoadingSx}>
          <Box
            component="img"
            src={cartIllustration}
            alt="Cart illustration"
            sx={discoveryCartIllustrationLoadingSx}
          />
          <Skeleton variant="text" width="70%"  height={28} sx={{ background: 'rgba(0, 0, 0, 0.04)', marginTop: '20px'}} />
          <Skeleton variant="text" width="40%" height={22} sx={{ background: 'rgba(0, 0, 0, 0.04)'}} />
        </Box>
      </Paper>
    </Box>
  </Box>
);
